module.exports = __webpack_public_path__ + "img/example.10271e1e.png";